/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LocationManager,
  LocationManagersListParams,
  PatchedPartialUpdateLocationManagerRequestRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getLocationManagersListUrl = (params?: LocationManagersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/location-managers/?${stringifiedParams}` : `/api/location-managers/`
}

export const locationManagersList = async (params?: LocationManagersListParams, options?: Parameters<typeof customFetch>[1]): Promise<LocationManager[]> => {

  return customFetch<LocationManager[]>(getLocationManagersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationManagersListQueryKey = (params?: LocationManagersListParams,) => {
    return [
    `/api/location-managers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationManagersListQueryOptions = <TData = Awaited<ReturnType<typeof locationManagersList>>, TError = void>(params?: LocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationManagersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationManagersList>>> = ({ signal }) => locationManagersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationManagersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationManagersListQueryResult = NonNullable<Awaited<ReturnType<typeof locationManagersList>>>
export type LocationManagersListQueryError = void


export function useLocationManagersList<TData = Awaited<ReturnType<typeof locationManagersList>>, TError = void>(
 params: undefined |  LocationManagersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationManagersList>>,
          TError,
          Awaited<ReturnType<typeof locationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationManagersList<TData = Awaited<ReturnType<typeof locationManagersList>>, TError = void>(
 params?: LocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationManagersList>>,
          TError,
          Awaited<ReturnType<typeof locationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationManagersList<TData = Awaited<ReturnType<typeof locationManagersList>>, TError = void>(
 params?: LocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationManagersList<TData = Awaited<ReturnType<typeof locationManagersList>>, TError = void>(
 params?: LocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationManagersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationManagersRetrieveUrl = (id: number,) => {




  return `/api/location-managers/${id}/`
}

export const locationManagersRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<LocationManager> => {

  return customFetch<LocationManager>(getLocationManagersRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationManagersRetrieveQueryKey = (id: number,) => {
    return [
    `/api/location-managers/${id}/`
    ] as const;
    }


export const getLocationManagersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationManagersRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationManagersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationManagersRetrieve>>> = ({ signal }) => locationManagersRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationManagersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationManagersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationManagersRetrieve>>>
export type LocationManagersRetrieveQueryError = void


export function useLocationManagersRetrieve<TData = Awaited<ReturnType<typeof locationManagersRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationManagersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationManagersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationManagersRetrieve<TData = Awaited<ReturnType<typeof locationManagersRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationManagersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationManagersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationManagersRetrieve<TData = Awaited<ReturnType<typeof locationManagersRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationManagersRetrieve<TData = Awaited<ReturnType<typeof locationManagersRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationManagersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationManagersPartialUpdateUrl = (id: number,) => {




  return `/api/location-managers/${id}/`
}

export const locationManagersPartialUpdate = async (id: number,
    patchedPartialUpdateLocationManagerRequestRequest?: PatchedPartialUpdateLocationManagerRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationManager>(getLocationManagersPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedPartialUpdateLocationManagerRequestRequest)
  }
);}





export const getLocationManagersPartialUpdateMutationKey = () => ['locationManagersPartialUpdate'] as const;

export const getLocationManagersPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationManagersPartialUpdate>>, TError,LocationManagersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationManagersPartialUpdate>>, TError,LocationManagersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getLocationManagersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationManagersPartialUpdate>>, LocationManagersPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  locationManagersPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationManagersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationManagersPartialUpdate>>>
    export type LocationManagersPartialUpdateMutationBody = PatchedPartialUpdateLocationManagerRequestRequest | undefined
    export type LocationManagersPartialUpdateMutationError = void
    export type LocationManagersPartialUpdateMutationVariables = {id: number;data?: PatchedPartialUpdateLocationManagerRequestRequest}

    export const useLocationManagersPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationManagersPartialUpdate>>, TError,LocationManagersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationManagersPartialUpdate>>,
        TError,
        LocationManagersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationManagersPartialUpdateMutationOptions(options), queryClient);
    }
    export const getLocationManagersDestroyUrl = (id: number,) => {




  return `/api/location-managers/${id}/`
}

export const locationManagersDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getLocationManagersDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLocationManagersDestroyMutationKey = () => ['locationManagersDestroy'] as const;

export const getLocationManagersDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationManagersDestroy>>, TError,LocationManagersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationManagersDestroy>>, TError,LocationManagersDestroyMutationVariables, TContext> => {

const mutationKey = getLocationManagersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationManagersDestroy>>, LocationManagersDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  locationManagersDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationManagersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof locationManagersDestroy>>>

    export type LocationManagersDestroyMutationError = void
    export type LocationManagersDestroyMutationVariables = {id: number}

    export const useLocationManagersDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationManagersDestroy>>, TError,LocationManagersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationManagersDestroy>>,
        TError,
        LocationManagersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getLocationManagersDestroyMutationOptions(options), queryClient);
    }
